import { polyfill } from 'seamless-scroll-polyfill';

import { isBrowserEnv } from '@nubank/www-latam-commons/utils/env/isBrowserEnv';

const callbacks = [];
if (isBrowserEnv) {
  polyfill();
}

export function addScript(src, cb) {
  if (callbacks.length === 0) {
    callbacks.push(cb);
    const s = document.createElement('script');
    s.setAttribute('src', src);
    s.onload = () => callbacks.forEach(callback => callback());
    document.body.appendChild(s);
  } else {
    callbacks.push(cb);
  }
}

export const smoothScroll = e => {
  e.preventDefault();
  const reference = e.target.getAttribute('href');
  const targetElement = document.querySelector(reference);
  const hasTargetElement = Boolean(targetElement);

  if (hasTargetElement && window.scrollTo) {
    const positionY = targetElement.offsetTop;
    window.scrollTo({ top: positionY, behavior: 'smooth' });
  }
};
